import { render, staticRenderFns } from "./FunctionManage.vue?vue&type=template&id=b48e06ae&scoped=true&"
import script from "./FunctionManage.vue?vue&type=script&lang=js&"
export * from "./FunctionManage.vue?vue&type=script&lang=js&"
import style0 from "./FunctionManage.vue?vue&type=style&index=0&id=b48e06ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e06ae",
  null
  
)

export default component.exports